import { useMemo } from 'react';

import { useCorporateConversionRates, useCurrentUser } from '../../hooks';
// eslint-disable-next-line max-len
import { ReservationConversionRateTable } from '../ReservationConversionRateTable/ReservationConversionRateTable.component';
import { buildFilters } from './common';
import { ReservationConversionRateProps } from './ReservationConversionRate.props';

export const CorporateReservationConversionRate = ({
  filters,
  expandedCompanies,
  setExpandedCompanies,
}: ReservationConversionRateProps) => {
  const currentUser = useCurrentUser();

  const queryFilters = useMemo(() => buildFilters(filters), [filters]);

  const list = useCorporateConversionRates(
    {
      filters: queryFilters,
    },
    currentUser.companyRef.id,
    filters?.companyIds
  );

  return (
    <ReservationConversionRateTable
      expandedCompanies={expandedCompanies}
      setExpandedCompanies={setExpandedCompanies}
      filters={filters}
      conversionRates={list}
    />
  );
};
